import { FETCH_POLICY } from 'common/apollo/FETCH_POLICY';
import { useTypedQuery } from 'utils/hooks/useTypedQuery';
import { HasLegacyInvoicesDocument } from './queries/__generated__/hasLegacyInvoices.graphql';
import { useTaeFlags } from 'src/components/pages/settings/TimesheetSettings/useTaeFlags';
import { useStaticPermission } from 'common/auth/Authorize';

const isTest = process.env.NODE_ENV === 'test';
export function useHasLegacyInvoices(callback: (hasLegacyInvoices: boolean) => void) {
  const { invoices } = useTaeFlags();
  const { READ } = useStaticPermission('INVOICE');

  const shouldRun = !isTest && invoices.v2 && READ;
  useTypedQuery(HasLegacyInvoicesDocument, {
    fetchPolicy: FETCH_POLICY.CACHE_FIRST,
    onCompleted: (data) => {
      const totalCount = data.allInvoices?.totalCount ?? 0;
      callback(totalCount > 0);
    },
    requestOnInit: shouldRun,
    context: {
      batch: false
    }
  });
}
